import { ReactNode } from "react";
import { PricingPage } from "./PricingPage";
import { useEntitlements } from "../hooks/useEntitlements";

interface PlanGateProps {
  children: ReactNode;
}

function StatusPanel({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="sign-in-gate">
      <div className="sign-in-status" role="status" aria-live="polite">
        <h1>{title}</h1>
        <p>{children}</p>
      </div>
    </div>
  );
}

// Gates the whole app on having ANY entitled tier. Reads the reactive
// Convex myEntitlements query — the same source requireOrg enforces, so
// the gate and the backend can never disagree. Replaces the old
// client-side Convex-JWT base64 decode (deleted with this change).
export function PlanGate({ children }: PlanGateProps) {
  const ent = useEntitlements();
  if (ent.kind === "loading") {
    return <StatusPanel title="Checking plan access">Loading your subscription…</StatusPanel>;
  }
  if (ent.kind === "no-plan") {
    return <PricingPage />;
  }
  return <>{children}</>;
}
